import React from 'react'
import { Icon as RIKIcon } from 'react-icons-kit'
import cx from 'classnames'

import styles from './Icon.module.scss'

export * from './model'

export const Icon = React.forwardRef(
  (
    {
      ariaLabel,
      className = undefined,
      onClick,
      icon,
      size = 16,
      style,
      title,
    },
    ref,
  ) => {
    if (typeof icon === 'string') {
      return (
        <img
          alt={ariaLabel || title || ''}
          className={cx(styles.icon, styles.assetIcon, {
            [className]: Boolean(className),
          })}
          height={size}
          onClick={onClick}
          ref={ref}
          src={icon}
          style={style}
          title={title}
          width={size}
        />
      )
    }

    return (
      <RIKIcon
        aria-label={ariaLabel}
        className={cx(styles.icon, { [className]: Boolean(className) })}
        role="img"
        itemRef={ref}
        {...{ icon, size, title, style, onClick }}
      />
    )
  },
)

